import { Button, ButtonGroup, FormGroup, H4, Intent, Menu, MenuDivider, MenuItem, Popover, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as configActions from "core/actions/configActions";
import * as editActions from "core/actions/editActions";
import { getPanelViewKey, getVariantList, getViewConfig } from "core/decorators/View";
import initialState from "core/reducers/initialState";
import StringUtil from "core/util/StringUtil";

interface IPanelViewEditProps {
	// own props
	panelInstance: string;
	viewId: string;
	viewKey: string;

	// from redux
	actions?: typeof configActions & typeof editActions;
	selectedVariant?: string;
	variants?: object;
}


class PanelViewEdit extends React.PureComponent<IPanelViewEditProps> {

	public render() {
		const variantKeys = Object.keys(this.props.variants);

		const rVariants = getVariantList(this.props.viewId);

		const selectedTitle = this.props.selectedVariant && this.props.variants[this.props.selectedVariant] && this.props.variants[this.props.selectedVariant]['__editName'];

		const intent: Intent = this.props.selectedVariant ? (
			this.props.variants[this.props.selectedVariant] ? Intent.SUCCESS : Intent.DANGER
		) : Intent.NONE;

		return (
			<FormGroup>
				<H4 children={`${this.props.viewKey} (${this.props.viewId})`} />
				<ButtonGroup>
					{
						variantKeys.length > 0 ? [
							<Popover
								content={
									<Menu>
										{
											variantKeys.map((k) => (
												<MenuItem
													key={k}
													icon={k === this.props.selectedVariant ? IconNames.TICK : undefined}
													onClick={this.selectVariant(k)}
													text={this.props.variants[k]['__editName'] || "Untitled Variant"}
												/>
											))
										}
									</Menu>
								}
								key="variant"
							>
								<Button
									text={selectedTitle ? `Selected: ${selectedTitle}` : "Select a Variant"}
									intent={intent}
								/>
							</Popover>,
							this.props.selectedVariant && (
								<Tooltip content="Clear Selection" key="clear">
									<Button icon={IconNames.CROSS} intent={intent} onClick={this.selectVariant(undefined)} />
								</Tooltip>
							),
							this.props.selectedVariant && this.props.variants[this.props.selectedVariant] && (
								<Tooltip content="Edit this variant" key="clear">
									<Button
										icon={IconNames.EDIT}
										intent={intent}
										onClick={() => this.props.actions.editSetActive({
											type: "view",
											id: this.props.viewId,
											instance: this.props.selectedVariant
										})}
									/>
								</Tooltip>
							)
						] : (
							<Button disabled={true} text="No Variants Available" />
						)
					}
					<Popover content={
						<Menu>
							<MenuDivider title="Add Variant" />
							{
								rVariants ? rVariants.filter((vid) => !variantKeys || variantKeys.indexOf(vid) < 0).map((vid) => (
									<MenuItem text={vid} key={vid} onClick={this.addNewVariant(vid)} />
								)) : (
									<MenuItem disabled={true} text="No Standard Variants For This View" />
								)
							}
							<MenuItem text="Custom" icon={IconNames.ADD} onClick={this.addNewVariant()} />
						</Menu>
					}>
						<Button icon={IconNames.ADD} intent={intent} text="Add New" />
					</Popover>
				</ButtonGroup>
			</FormGroup>
		);
	}

	private addNewVariant = (variantId?: string) => () => {
		const uuid = variantId || StringUtil.generateUuid();

		const ViewConfig = getViewConfig(this.props.viewId);

		this.props.actions.configViewAdd(this.props.viewId, uuid, ViewConfig ? new ViewConfig() : {});
		this.props.actions.configPanelViewAdd(getPanelViewKey(this.props.panelInstance, this.props.viewKey), uuid);
		this.props.actions.editSetActive({type: "view", id: this.props.viewId, instance: uuid});
	}

	private selectVariant = (variantId: string) => () => {
		this.props.actions.configPanelViewAdd(getPanelViewKey(this.props.panelInstance, this.props.viewKey), variantId);
	}
}

function mapStateToProps(state = initialState, ownProps: IPanelViewEditProps) {

	return {
		selectedVariant: state.config.panelViews[getPanelViewKey(ownProps.panelInstance, ownProps.viewKey)] || null,
		variants: state.config.views[ownProps.viewId] || {}
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: {
			...bindActionCreators(configActions, dispatch),
			...bindActionCreators(editActions, dispatch)
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PanelViewEdit);



// WEBPACK FOOTER //
// ./src/core/components/editor/panels/PanelViewEdit.tsx